import { useQuery } from '@src/shared/query';

export type PhoneBookUserDto = {
  id: number;
  name: string;
  portrait: string | null;
  job_title: string | null;
  phone: string | null;
  mobile: string | null;
  online: boolean;
};

export type PhoneBookUser = {
  id: number;
  name: string;
  portrait: string | null;
  jobTitle: string | null;
  phone: string | null;
  mobile: string | null;
  online: boolean;
};

function phoneBookUserFromDto(dto: PhoneBookUserDto): PhoneBookUser {
  const { job_title, ...rest } = dto;
  return {
    ...rest,
    jobTitle: job_title,
  };
}

export function usePhoneBookUsers() {
  const query = useQuery<PhoneBookUserDto[], PhoneBookUser[]>(
    'users/phone-book/',
    {
      select: (data) => data.map(phoneBookUserFromDto),
    },
  );

  const { data: users = [], ...restQuery } = query;
  return { users, ...restQuery };
}
